import { enableProdMode, provideZonelessChangeDetection, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from './environments/environment';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import { CurrencyPipe } from '@angular/common';
import { DateAdapter } from '@angular/material/core';
import { CustomDateAdapter } from './app/custom-date-adapter';
import { DateAdapter as AngularCalendarDateAdapter, provideCalendar } from 'angular-calendar';
import { provideRouter } from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideHttpClient, withInterceptorsFromDi, withFetch } from '@angular/common/http';
import { routes } from './app/app.routes';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { AppComponent } from './app/app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
};

if (environment.production) {
  enableProdMode();
  if (localStorage.getItem('testMode') !== 'true') {
    window.console.log = window.console.warn = window.console.info = function () {};
  }
}

registerLocaleData(localeNl);

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideAnimationsAsync(),
    provideRouter(routes),
    provideNativeDateAdapter(),
    provideCalendar({
      provide: AngularCalendarDateAdapter,
      useFactory: adapterFactory,
    }),
    { provide: LOCALE_ID, useValue: 'nl' },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: appearance,
    },
    CurrencyPipe,
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
  ],
}).catch((err) => console.error(err));
